import { ReactNode } from "react";
import "./style.scss";

interface LabelProps {
  children: ReactNode;
  required?: boolean;
}

const Label = (props: LabelProps) => {
  const { children, required } = props;

  return (
    <div className="params__label">
      {children} {required && <span className="params__label__required">*</span>}
    </div>
  );
};

export default Label;
